import { Link } from "react-router-dom";

export default function TipSheetUsageTable({
  topRequests,
}) {
  return (
    <table className="dashboard-table">
      <thead>
        <tr>
          <th className="dashboard-table-th">50 Most Accessed Tip Sheets</th>
          <th className="dashboard-table-th"># of Accesses</th>
        </tr>
      </thead>
      <tbody>
        {topRequests.map((req, i) => {
          return (
            <tr key={i} className={i % 2 === 0 ? "dashboard-table-tr-even" : ""}>
              <td className="dashboard-table-td" style={{ width: "60%" }}>
                <Link to={`/${req[0]}`} target="_blank">{req[0]}</Link>
              </td>
              <td className="dashboard-table-td" style={{ width: "40%" }}>{req[1]}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  )
}